import {Injectable} from '@angular/core';
import {Http, Response, Headers, RequestOptions} from '@angular/http';
import {Observable} from 'rxjs/Observable';
import { TranslateService } from 'ng2-translate';
const json = require("json!./../../../../resources/properties.json");

@Injectable()
export class ElementDetailService {
    
    private token: string;
    private _mainUrl = '/mainData';
    private _elementDetailUrl = '/elementDetailData';
    private serverURL: string;
   
    constructor(private _translateService: TranslateService, private http: Http) {
        this.serverURL = json.api_url;
        this.getTokenService();
    }    

    getElementsById(element_id: Number) {        
        var token = localStorage.getItem('token');
        var authHeader = new Headers({'Content-Type': 'application/x-www-form-urlencoded'});
        
        if (token) {
            authHeader.append('Authorization', 'Bearer ' + token);
        }
        
        var language = this._translateService.currentLang;
        let options = new RequestOptions({ headers: authHeader, body: "" }); 

        var url: string;
        if(token == null || token == undefined || token == "") {
            url = `${this._elementDetailUrl}/${language}/${element_id}`;
        } else {
            url = `${this._elementDetailUrl}/authenticated/${language}/${element_id}`;
        }               

        return this.http.get(this.serverURL + url, options).toPromise().then(res => { 
            
            if(JSON.parse(res.text()).code == 1) {
                return JSON.parse(res.text()).rows[0];
            } else {
                return null;
            }            
        
        }, this.handleError);
    }

    manageFavorite(element_id: number) {

        var token = localStorage.getItem('token');
        var authHeader = new Headers({'Content-Type': 'application/x-www-form-urlencoded'});

        if (token) {

            authHeader.append('Authorization', 'Bearer ' + token);

        }
        
        
        return this.http.post(this.serverURL + this._mainUrl, this.serializeObj({id: element_id}), {headers: authHeader}).toPromise().then(result => {
        
            return JSON.parse(result.text());            

        }).catch(this.handleError);

    }

    sendMessage(messageTitle: string, messageContent: string, messageUserReceiverId: number) {

        var token = localStorage.getItem('token');
        var authHeader = new Headers({'Content-Type': 'application/x-www-form-urlencoded'});

        if (token) {

            authHeader.append('Authorization', 'Bearer ' + token);

        }
                
        return this.http.post(this.serverURL + this._mainUrl + "/message", this.serializeObj({message_title: messageTitle, message_content: messageContent, message_userReceiverId: messageUserReceiverId}), {headers: authHeader}).toPromise().then(result => {
                    
            return JSON.parse(result.text());

        }).catch(this.handleError);

    }

    login(email: string, password: string) {

        let creds = "email=" + email + "&password=" + password;

        return this.http.post(this.serverURL + '/loginData', creds, { headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded'})}).map((res: any) => {
            let data = res.json();
            if (data.token !== undefined) {
                this.token = data.token;
                localStorage.setItem('token', this.token);
            }            
            return data;
        });

    }

    getUserStatus(): Promise<any> {
        
        let token = localStorage.getItem('token');
        let authHeader = new Headers({
            'Content-Type': 'application/x-www-form-urlencoded'
        });

        if (token != null && token != "") {

            authHeader.append('Authorization', 'Bearer ' + token);
            let options = new RequestOptions({ headers: authHeader, body: "" });
            return this.http.get(this.serverURL + '/loginData/userStatus', options).toPromise().then(res => {
                if (JSON.parse(res.text()).code == -1) {
                    return "guest";
                } else {
                    return JSON.parse(res.text());
                }
            }).catch(this.handleError);
        } else {
            return new Promise((resolve, reject) => {
                return "guest";
            })
        }

    }

    getTokenService() {
        this.token = localStorage.getItem('token');
    }

    private handleError (error:Response) {
        console.error(error);
        return Observable.throw(error.json().error || 'Server error');
    }        

    private serializeObj(obj: any) {
        var result: any[] = [];

        for (var property in obj)
            result.push(encodeURIComponent(property) + "=" + encodeURIComponent(obj[property]));

        return result.join("&");
    }    
}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/main/element_detail/element-detail.service.ts
 **/